export default __webpack_public_path__ + "static/media/family-on-sofa-with-umbrella.fc5d68d1.svg";